import { F0AvatarIcon, F0Box, F0Heading, F0TagStatus, F0Text } from '@factorialco/f0-react'
import { Desktop } from '@factorialco/f0-react/icons/app'

import type { PurchaseOrderDetailFieldsFragment } from 'generated/resources/graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { statusBadgeVariant, statusLabel } from './utils'

interface Props {
  purchaseOrder: PurchaseOrderDetailFieldsFragment
  locale: string
}

function HeaderBanner({ purchaseOrder, locale }: Props) {
  const orderDate = purchaseOrder.date ? dateBackendDateTimeToUI(purchaseOrder.date) : null

  const totalFormatted = MoneyWithCurrency({
    amount: Number(purchaseOrder.cost.cents),
    currency: purchaseOrder.cost.currency,
    locale,
  })

  const taxTotalCents = purchaseOrder.taxTotal ? Number(purchaseOrder.taxTotal) : null
  const taxFormatted =
    taxTotalCents !== null
      ? MoneyWithCurrency({
          amount: taxTotalCents,
          currency: purchaseOrder.cost.currency,
          locale,
        })
      : null

  return (
    <F0Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="lg"
      paddingTop="md"
      paddingBottom="md"
      paddingRight="md"
      paddingLeft="sm"
    >
      <F0AvatarIcon icon={Desktop} size="lg" />
      <F0Box display="flex" flexDirection="column" gap="xs" grow>
        <F0Box display="flex" flexDirection="row" gap="md" alignItems="center">
          <F0Heading as="h3" content={purchaseOrder.formattedPoNumber} />
          <F0TagStatus
            text={statusLabel(purchaseOrder.status)}
            variant={statusBadgeVariant(purchaseOrder.status)}
          />
        </F0Box>
        {orderDate && <F0Text content={orderDate} variant="description" />}
      </F0Box>
      <F0Box display="flex" flexDirection="column" alignItems="end" gap="xs">
        <F0Heading as="h3" content={totalFormatted} />
        {taxFormatted && (
          <F0Text
            content={i18n.t('procurement.purchase_orders.detail.incl_tax', {
              amount: taxFormatted,
            })}
            variant="description"
          />
        )}
      </F0Box>
    </F0Box>
  )
}

export default HeaderBanner
